import { Component, OnInit } from '@angular/core';
import { SettingsService} from '../../services/settings.service';
import { AuthService} from '../../services/auth.service';


@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

  editedData = {
    id: localStorage.getItem("idUser"), 
    email: localStorage.getItem("emailUser"), 
    settings: localStorage.getItem("settingsUser"),
    menuImage: localStorage.getItem("menuImage")
  };

  editedPassword = {
    id: localStorage.getItem("idUser"), 
    login: localStorage.getItem("loginUser"), 
    oldPassword: '', 
    newPassword: '', 
    newPasswordAgain: ''
  };

  constructor(private settingsService: SettingsService, private authService: AuthService) { }

  ngOnInit() {
    this.settingsService.isLoaded = true;
    this.settingsService.isActual = true;
    /*this.settingsService.errorText = "";
    this.settingsService.successText = "";
    this.settingsService.successPasText = "";*/

  }

  updateUser(){
    this.settingsService.updateUser(this.editedData);
    
  }
  updateUserPas(){
    this.settingsService.updateUserPas(this.editedPassword);
    this.editedPassword.oldPassword = '';
    this.editedPassword.newPassword = '';
    this.editedPassword.newPasswordAgain = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/components/user/user.component.ts